export const shareUrl = (id) => `${window.location.origin}/share/${id}`;

const day = (iso) => new Date(iso).toLocaleDateString([], { day: "numeric", month: "short", year: "numeric" });
export const expiryText = (l) => (l.status === "expired" ? `Expired ${day(l.expires_at)}` : l.expires_at ? `Expires ${day(l.expires_at)}` : "Never expires");

export const whatsappUrl = (url, name) => `https://wa.me/?text=${encodeURIComponent(`3D view of ${name || "your windows & doors"} — spin it on your phone: ${url}`)}`;

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const t = document.createElement("textarea");
    t.value = text;
    document.body.appendChild(t);
    t.select();
    document.execCommand("copy");
    t.remove();
  }
}
